import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "inline-flex items-center justify-center",
    "aria-hidden": "true"
};
import { computed, toRef } from 'vue';
import { shouldShowCartTrashIcon } from '@shared/utils/cartItemQuantity';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartQuantityDecreaseIcon',
    props: {
        quantity: {},
        sizeClass: { default: 'text-sm' }
    },
    setup(__props) {
        const props = __props;
        const quantityRef = toRef(props, 'quantity');
        const showTrash = computed(() => shouldShowCartTrashIcon(quantityRef.value));
        const iconClass = computed(() => {
            if (props.sizeClass === 'text-xs') {
                return 'h-3 w-3';
            }
            return 'h-3.5 w-3.5';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                (showTrash.value)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        class: _normalizeClass(iconClass.value)
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9.425a.75.75 0 0 0 1.499-.058l-.346-9.425Zm5.48-.058a.75.75 0 1 0-1.498.058l-.347 9.425a.75.75 0 0 0 1.498-.058l.347-9.425Z",
                                "clip-rule": "evenodd"
                            }, null, -1 /* CACHED */)
                        ]))], 2 /* CLASS */))
                    : (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        class: _normalizeClass(iconClass.value)
                    }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z",
                                "clip-rule": "evenodd"
                            }, null, -1 /* CACHED */)
                        ]))], 2 /* CLASS */))
            ]));
        };
    }
});
